import moment from 'moment';

const LOCAL_STORAGE_KEY = 'banner-state-v6';

function parseJsonOrUndefined(text) {
  try {
    return JSON.parse(text);
  } catch (error) {
    return undefined;
  }
}

function getTodayKey(currentTime, userEmail) {
  if (typeof currentTime !== 'number') throw new TypeError('currentTime must be a number');
  if (typeof userEmail !== 'string') throw new TypeError('userEmail must be a string');
  return moment(currentTime).format('YYYY-MM-DD') + '--' + userEmail;
}

export function getTodayBannerState(currentTime, userEmail) {
  if (typeof currentTime !== 'number') throw new TypeError('currentTime must be a number');
  if (typeof userEmail !== 'string') throw new TypeError('userEmail must be a string');
  const todayKey = getTodayKey(currentTime, userEmail);
  const bannerStateRaw = localStorage.getItem(LOCAL_STORAGE_KEY) || '';
  const bannerState = parseJsonOrUndefined(bannerStateRaw) || {};
  const todayBannerState = bannerState[todayKey] || {};

  return {
    haveSeenPopupDailySummary: todayBannerState.haveSeenPopupDailySummary || false,
    haveSeenPopupFiftyCalls: todayBannerState.haveSeenPopupFiftyCalls || false,
  };
}

export function setTodayBannerState({haveSeenPopupDailySummary, haveSeenPopupFiftyCalls}, currentTime, userEmail) {
  if (typeof currentTime !== 'number') throw new TypeError('currentTime must be a number');
  if (typeof userEmail !== 'string') throw new TypeError('userEmail must be a string');
  const todayKey = getTodayKey(currentTime, userEmail);
  const todayBannerState = {haveSeenPopupDailySummary, haveSeenPopupFiftyCalls};
  const bannerState = {[todayKey]: todayBannerState};
  const bannerStateRaw = JSON.stringify(bannerState);
  localStorage.setItem(LOCAL_STORAGE_KEY, bannerStateRaw);
}
